module.exports = __webpack_public_path__ + "static/img/5.da56c54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/5.jpg
// module id = vFvX
// module chunks = 1